import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const TeamAssignmentIcon = memo(({ className, fontSize = 120 }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="190"
    height="119"
    viewBox="0 0 190 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fontSize, fill: 'none' }}
  >
    <path
      d="M18.6346 113.657V116.146V115.236C18.6346 115.479 18.8173 115.661 19.0609 115.661H61.4455C61.6891 115.661 61.8718 115.479 61.8718 115.236V116.146V72.25L75.5737 77.6536C75.6955 77.7143 75.8173 77.7143 75.9391 77.6536C76.0609 77.5929 76.1218 77.4714 76.1827 77.35L76.3045 76.8643L84.0385 80.0821C84.6475 80.325 85.2564 80.4464 85.8654 80.4464C86.4744 80.4464 87.0834 80.325 87.6923 80.0821C88.8494 79.5964 89.8237 78.6857 90.3109 77.4714L102.064 49.2393C102.125 49.1179 102.125 48.9964 102.064 48.875C102.003 48.7536 101.942 48.6929 101.821 48.6321C95.9135 46.2036 89.093 48.9964 86.6571 54.8857L81.968 66.1786L79.4712 65.1464L79.8975 63.6893C79.9584 63.5071 79.8366 63.2643 79.6539 63.1429L53.8943 52.0929L50.1795 48.3893V48.3286V44.8679C52.9199 43.1679 54.625 40.1929 54.625 36.975V32.1786H57.3045C59.2532 32.1786 60.8975 30.6 60.8975 28.5964C60.8975 26.5929 59.3141 25.0143 57.3045 25.0143H54.625V19.6107C56.5128 20.4 57.6699 21.0679 57.6699 21.0679C57.8526 21.1893 58.1571 21.1286 58.2789 20.9464C58.4007 20.7643 58.3398 20.4607 58.1571 20.3393C58.0962 20.3393 56.8173 19.55 54.625 18.6393V13.9643C54.625 8.86429 50.484 4.73572 45.3686 4.73572H40.984C35.8686 4.73572 31.7276 8.86429 31.7276 13.9643V19.2464C31.1186 19.6107 30.4487 19.975 29.8398 20.4C29.6571 20.5214 29.5962 20.825 29.718 21.0071C29.7789 21.1286 29.9616 21.1893 30.0834 21.1893C30.1443 21.1893 30.2661 21.1893 30.327 21.1286C30.8141 20.825 31.2404 20.5214 31.7276 20.2786V25.075H29.0481C27.0994 25.075 25.4552 26.6536 25.4552 28.6571C25.4552 30.6607 27.0385 32.2393 29.0481 32.2393H31.7276V35.275C31.7276 38.1286 32.8846 40.8607 34.8334 42.8643C34.8334 42.925 34.8334 42.925 34.8334 42.9857L34.6507 48.3893L32.3366 50.6964L15.6507 56.8286C10.3526 58.7714 6.75964 63.9321 6.75964 69.5786V78.9286V113.9L18.6346 113.657Z"
      fill="#F0CBA7"
    />
    <path
      d="M61.4456 116.632H19.0609C18.8174 116.632 18.6347 116.45 18.6347 116.207V79.3536H7.24684C7.00325 79.3536 6.82056 79.1714 6.82056 78.9286V69.5786C6.82056 63.9322 10.4135 58.8322 15.7116 56.8286L32.3975 50.6357L34.8334 48.2072C35.0161 48.025 35.2597 48.025 35.4424 48.2072L42.4456 55.1286L49.3879 48.2072C49.5706 48.025 49.8142 48.025 49.9968 48.2072L53.8943 52.0929L79.6539 63.2643C79.8366 63.325 79.9584 63.5679 79.8975 63.8107L76.1827 77.4107C76.1218 77.5322 76.0609 77.6536 75.9391 77.7143C75.8174 77.775 75.6956 77.775 75.5738 77.7143L61.8718 72.3107V116.207C61.8718 116.45 61.6892 116.632 61.4456 116.632Z"
      fill="#E8EFEA"
    />
    <path
      d="M29.8398 20.4C30.4488 19.975 31.1186 19.6107 31.7276 19.2464V14.025C31.7276 8.92496 35.8686 4.79639 40.984 4.79639H45.3686C50.484 4.79639 54.625 8.92496 54.625 14.025V18.7607C56.7565 19.6107 58.0962 20.4 58.1571 20.4607C58.3398 20.5821 58.4007 20.8857 58.2789 21.0678C58.1571 21.25 57.8526 21.3107 57.6699 21.1892C57.5481 21.1285 50.8494 17.1214 42.5065 17.3035C42.3847 17.3035 42.2629 17.3035 42.1411 17.3035C41.8975 17.3035 41.593 17.3035 41.3494 17.3642C41.1058 17.3642 40.8622 17.425 40.6186 17.425C40.4359 17.425 40.2532 17.4857 40.0706 17.4857C39.5834 17.5464 39.1571 17.6071 38.6699 17.7285C38.1827 17.85 37.6956 17.9107 37.2084 18.0928C37.1475 18.0928 37.0866 18.0928 37.0257 18.1535C35.5032 18.5785 33.9199 19.1857 32.3975 19.975C31.7276 20.3392 31.0577 20.7642 30.3879 21.1892C30.327 21.25 30.2052 21.25 30.1443 21.25C30.0225 21.25 29.8398 21.1892 29.7789 21.0678C29.5962 20.825 29.6571 20.5214 29.8398 20.4Z"
      fill="#E8EFEA"
    />
    <path
      d="M178.673 55.0679L161.987 48.875L159.612 46.5071V41.3464C159.612 41.2857 159.612 41.2857 159.612 41.225C161.622 39.1607 162.718 36.4286 162.718 33.6357V30.6H165.397C167.346 30.6 168.99 29.0214 168.99 27.0179C168.99 25.075 167.407 23.4357 165.397 23.4357H162.718V18.6393C163.205 18.8822 163.631 19.1857 164.119 19.4893C164.301 19.6107 164.606 19.55 164.728 19.3679C164.849 19.1857 164.788 18.8821 164.606 18.7607C163.997 18.3357 163.327 17.9714 162.718 17.6072V12.325C162.718 7.22501 158.577 3.09644 153.462 3.09644H149.077C143.962 3.09644 139.821 7.22501 139.821 12.325V17.0607C137.689 17.9107 136.349 18.7 136.288 18.7607C136.106 18.8821 136.045 19.1857 136.167 19.3679C136.228 19.4893 136.41 19.55 136.532 19.55C136.593 19.55 136.715 19.55 136.776 19.4893C136.837 19.4893 137.933 18.7607 139.821 18.0322V23.4357H137.141C135.192 23.4357 133.548 25.0143 133.548 27.0179C133.548 28.9607 135.131 30.6 137.141 30.6H139.821V35.3964C139.821 38.6143 141.526 41.5893 144.266 43.2893V46.5679L140.186 50.6357L140.125 50.6964L130.808 54.8857C126.058 57.0107 120.272 61.9893 118.933 67.8179L117.167 78.0179C117.106 78.2607 117.288 78.4429 117.471 78.5036L117.897 78.625L116.74 83.725L104.805 81.0536C101.76 80.3857 98.6539 80.9321 96.0353 82.5714C93.4167 84.2107 91.5898 86.7607 90.9199 89.7964C90.859 90.0393 91.0417 90.2822 91.2244 90.3429L121.125 97.0214C121.49 97.0821 121.856 97.1429 122.16 97.1429C123.074 97.1429 123.926 96.9 124.718 96.4143C125.814 95.7464 126.545 94.6536 126.849 93.4393L129.59 81.4179L130.321 81.6C130.442 81.6 130.564 81.6 130.686 81.5393C130.808 81.4786 130.869 81.3571 130.869 81.2357L132.269 74.3143V114.568V114.325C132.269 114.568 132.452 114.75 132.696 114.75H175.08C175.324 114.75 175.506 114.568 175.506 114.325V114.568V94.4714L182.631 94.4107C185.25 94.35 187.381 92.1643 187.381 89.5536V77.1072V67.7571C187.564 62.1714 183.971 57.0107 178.673 55.0679Z"
      fill="#F0CBA7"
    />
    <path
      d="M164.606 18.7607C163.997 18.3357 163.327 17.9714 162.718 17.6071V12.3857C162.718 7.28568 158.577 3.1571 153.462 3.1571H149.077C143.962 3.1571 139.82 7.28568 139.82 12.3857V17.1214C137.689 17.9714 136.349 18.7607 136.288 18.8214C136.106 18.9428 136.045 19.2464 136.167 19.4285C136.288 19.6107 136.593 19.6714 136.776 19.55C136.897 19.4892 143.596 15.4821 151.939 15.6642C152.061 15.6642 152.183 15.6642 152.304 15.6642C152.548 15.6642 152.853 15.6642 153.096 15.725C153.34 15.725 153.583 15.7857 153.827 15.7857C154.01 15.7857 154.192 15.8464 154.375 15.8464C154.862 15.9071 155.288 15.9678 155.776 16.0892C156.263 16.2107 156.75 16.2714 157.237 16.4535C157.298 16.4535 157.359 16.4535 157.42 16.5142C158.942 16.9392 160.526 17.5464 162.048 18.3357C162.718 18.7 163.388 19.125 164.058 19.55C164.119 19.6107 164.24 19.6107 164.301 19.6107C164.423 19.6107 164.606 19.55 164.667 19.4285C164.849 19.125 164.788 18.8821 164.606 18.7607Z"
      fill="#E8EFEA"
    />
    <path
      d="M3.04492 115.479V77.1072H14.859"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.8814 53.3678L78.0096 65.0856L74.7821 63.7499L71.7981 74.5571L80.0192 77.9571C82.2725 78.8678 84.7692 77.8356 85.7436 75.5892L97.4359 47.3571C91.7725 44.9892 85.2564 47.7214 82.8814 53.3678Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.859 77.1071V69.8821"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.0609 59.1357C38.5318 59.1357 38.9135 58.7551 38.9135 58.2857C38.9135 57.8162 38.5318 57.4357 38.0609 57.4357C37.5901 57.4357 37.2084 57.8162 37.2084 58.2857C37.2084 58.7551 37.5901 59.1357 38.0609 59.1357Z"
      fill="#226937"
    />
    <path
      d="M38.0609 62.5964C38.5318 62.5964 38.9135 62.2158 38.9135 61.7464C38.9135 61.2769 38.5318 60.8964 38.0609 60.8964C37.5901 60.8964 37.2084 61.2769 37.2084 61.7464C37.2084 62.2158 37.5901 62.5964 38.0609 62.5964Z"
      fill="#226937"
    />
    <path
      d="M38.0609 65.8749C38.5318 65.8749 38.9135 65.4944 38.9135 65.0249C38.9135 64.5555 38.5318 64.1749 38.0609 64.1749C37.5901 64.1749 37.2084 64.5555 37.2084 65.0249C37.2084 65.4944 37.5901 65.8749 38.0609 65.8749Z"
      fill="#226937"
    />
    <path
      d="M146.824 20.2786L144.51 28.9H149.442"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M175.689 93.925V114.446C175.689 114.689 175.506 114.871 175.263 114.871H132.878C132.635 114.871 132.452 114.689 132.452 114.446V74.1929L131.051 81.1143C131.051 81.2357 130.929 81.3572 130.869 81.4179C130.747 81.4786 130.625 81.4786 130.503 81.4786L117.593 78.4429C117.349 78.3822 117.228 78.2 117.288 77.9572L119.054 67.7572V67.6965C120.394 61.9286 126.119 57.0107 130.869 54.825L140.186 50.6357L140.247 50.575L144.327 46.5072C144.388 46.4465 144.51 46.3857 144.631 46.3857C144.753 46.3857 144.875 46.4465 144.936 46.5072L146.519 48.0857L152.122 53.2465L158.942 46.5072C159.003 46.4465 159.125 46.3857 159.247 46.3857C159.369 46.3857 159.49 46.4465 159.551 46.5072L161.987 48.9357L178.673 55.1286C183.971 57.0715 187.564 62.2322 187.564 67.8786V77.1072C187.564 77.35 187.381 77.5322 187.138 77.5322H175.324L175.689 93.925Z"
      fill="#E8EFEA"
    />
    <path
      d="M144.083 33.3928C144.083 33.3928 148.894 35.275 151.391 31.7535"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M139.394 19.1857C139.394 19.1857 141.099 17.3643 143.231 17.7286"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M150.417 17.3643C150.417 17.3643 152.974 17.7285 153.523 19.1857"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M132.635 28.3535H135.74V22.1H132.635C130.929 22.1 129.529 23.4964 129.529 25.1964C129.529 26.9571 130.929 28.3535 132.635 28.3535Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M160.891 22.1H157.785V28.3535H160.891C162.596 28.3535 163.997 26.9571 163.997 25.2571C164.058 23.4964 162.657 22.1 160.891 22.1Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M167.285 83.2393V72.1285H139.881V109.529H167.285V94.4107" fill="#F0CBA7" />
    <path
      d="M158.394 81.175L163.327 81.1143V70.0035H135.923V107.404H163.327V92.2857L147.433 92.4678C147.311 86.275 152.244 81.2357 158.394 81.175Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.676 52.0928C147.737 52.0928 147.737 52.0928 147.676 52.0928L153.644 46.1428L154.679 45.1107C154.679 45.05 154.679 44.9893 154.679 44.8678V39.525H154.375C156.506 37.5821 157.785 34.85 157.785 31.8143V10.5643C157.785 5.76784 153.827 1.82141 149.016 1.82141H144.631C139.76 1.82141 135.801 5.76784 135.801 10.5643V33.575C135.801 36.8536 137.628 39.7071 140.247 41.1643V44.9286C140.247 44.9893 140.247 45.05 140.247 45.1714L141.769 46.6893L147.676 52.0928Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M157.785 16.0893V10.5643C157.785 5.76784 153.827 1.82141 149.016 1.82141H144.631C139.76 1.82141 135.801 5.76784 135.801 10.5643V15.5428C140.612 13.7214 149.321 11.5357 157.785 16.0893Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M132.087 17.3643C132.087 17.3643 146.763 8.43925 159.917 17.3643"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M112.721 82.3893L100.359 79.5964C94.3302 78.2607 88.3622 82.025 87.0225 87.975L116.923 94.6535C119.298 95.2 121.612 93.6821 122.16 91.375L124.962 78.9285L114.122 76.3785L112.721 82.3893Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M140.003 85.9106V90.5856"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M142.378 85.9106V90.5856"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M142.378 88.2784H140.003"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M144.205 85.9106V89.3714C144.205 90.0392 144.753 90.5856 145.423 90.5856C146.093 90.5856 146.641 90.0392 146.641 89.3714V85.9106"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.01 77.5321V83.1179L165.519 83.2393L160.587 83.3C154.436 83.4214 149.503 88.4607 149.625 94.5929L165.519 94.4107L173.01 94.2893L180.561 94.1679C182.997 94.1072 184.885 92.1643 184.824 89.7357V77.4714L173.01 77.5321Z"
      fill="#F0CBA7"
    />
    <path
      d="M170.817 75.3464V80.9321L163.327 81.0535L158.394 81.1142C152.244 81.2356 147.311 86.2749 147.433 92.4071L163.327 92.2249L170.817 92.1035L178.369 91.9821C180.804 91.9214 182.692 89.9785 182.631 87.5499V75.2856L170.817 75.3464Z"
      stroke="#E87525"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M147.616 57.375C148.086 57.375 148.468 56.9945 148.468 56.525C148.468 56.0556 148.086 55.675 147.616 55.675C147.145 55.675 146.763 56.0556 146.763 56.525C146.763 56.9945 147.145 57.375 147.616 57.375Z"
      fill="#046A37"
    />
    <path
      d="M147.616 60.8357C148.086 60.8357 148.468 60.4552 148.468 59.9857C148.468 59.5163 148.086 59.1357 147.616 59.1357C147.145 59.1357 146.763 59.5163 146.763 59.9857C146.763 60.4552 147.145 60.8357 147.616 60.8357Z"
      fill="#046A37"
    />
    <path
      d="M147.616 64.1143C148.086 64.1143 148.468 63.7337 148.468 63.2643C148.468 62.7949 148.086 62.4143 147.616 62.4143C147.145 62.4143 146.763 62.7949 146.763 63.2643C146.763 63.7337 147.145 64.1143 147.616 64.1143Z"
      fill="#046A37"
    />
    <path
      d="M147.342 52.1372L140.194 45.0106L136.103 49.0891L143.251 56.2156L147.342 52.1372Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M154.801 44.9893L154.68 45.1107L153.644 46.1428L147.615 52.1535L151.696 56.2214L158.882 49.1178L154.801 44.9893Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M170.817 75.3464H182.631V65.9964C182.631 60.5322 179.221 55.6143 174.045 53.6714L157.237 47.4786L154.74 44.9893L147.676 52.0322L141.769 46.5679L140.247 45.05L140.125 44.9286L136.045 48.9964L136.106 49.0572L126.545 53.4286C121.551 55.675 116.192 60.6536 114.974 65.9964L113.208 76.1964L114.061 76.3786L124.901 78.9286L126.119 79.2322L128.433 68.1214V82.9964V112.686H170.817V92.1643"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M170.817 75.3465V68.1215"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M170.817 75.3464H182.631"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M141.221 23.6785C141.759 23.6785 142.196 22.9718 142.196 22.0999C142.196 21.2281 141.759 20.5214 141.221 20.5214C140.683 20.5214 140.247 21.2281 140.247 22.0999C140.247 22.9718 140.683 23.6785 141.221 23.6785Z"
      fill="#046A37"
    />
    <path
      d="M151.939 23.6785C152.477 23.6785 152.914 22.9718 152.914 22.0999C152.914 21.2281 152.477 20.5214 151.939 20.5214C151.401 20.5214 150.965 21.2281 150.965 22.0999C150.965 22.9718 151.401 23.6785 151.939 23.6785Z"
      fill="#046A37"
    />
    <path
      d="M145.362 5.58569V10.2607"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.737 5.58569V10.2607"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.737 7.89282H145.362"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.1218 7.22498V11.9"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.4968 7.22498V11.9"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.4968 9.5321H38.1218"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M154.375 39.5857C154.375 39.5857 152.731 40.8 150.112 41.1643"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M140.247 41.225C140.247 41.225 141.708 42.2571 144.022 42.2571"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.0353 21.9785L41.2885 30.5999H36.3558"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.7757 35.0929C41.7757 35.0929 36.9648 36.975 34.468 33.4536"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.4039 20.825C46.4039 20.825 44.6988 19.0036 42.5674 19.3679"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.3814 19.0035C35.3814 19.0035 32.8237 19.3678 32.2756 20.825"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.1635 29.9928H50.0577V23.7393H53.1635C54.8686 23.7393 56.2693 25.1357 56.2693 26.8357C56.2693 28.5964 54.8686 29.9928 53.1635 29.9928Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.9071 23.7393H28.0129V29.9928H24.9071C23.202 29.9928 21.8014 28.5964 21.8014 26.8964C21.7405 25.1357 23.1411 23.7393 24.9071 23.7393Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.3654 53.9142H38.0609L32.1538 48.0249L30.9359 46.7499C30.9359 46.6892 30.9359 46.6892 30.9359 46.6285L31.1186 41.2249H31.4231C29.2917 39.2821 28.0128 36.5499 28.0128 33.5142V12.2642C28.0128 7.46779 31.9712 3.52136 36.782 3.52136H41.1667C45.9776 3.52136 49.9359 7.46779 49.9359 12.2642V35.2749C49.9359 38.5535 48.109 41.4071 45.4904 42.8642V46.5678C45.4904 46.6285 45.4904 46.6892 45.4904 46.8107L43.9679 48.3285L38.3654 53.9142Z"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0128 17.7285V12.2036C28.0128 7.40712 31.9712 3.46069 36.782 3.46069H41.1667C45.9776 3.46069 49.9359 7.40712 49.9359 12.2036V17.1821C45.2468 15.3607 36.4776 13.175 28.0128 17.7285Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.7725 19.0035C53.7725 19.0035 39.0962 10.0785 25.9424 19.0035"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.577 25.3178C45.1151 25.3178 45.5514 24.611 45.5514 23.7392C45.5514 22.8674 45.1151 22.1606 44.577 22.1606C44.0389 22.1606 43.6027 22.8674 43.6027 23.7392C43.6027 24.611 44.0389 25.3178 44.577 25.3178Z"
      fill="#046A37"
    />
    <path
      d="M33.859 25.3178C34.3971 25.3178 34.8334 24.611 34.8334 23.7392C34.8334 22.8674 34.3971 22.1606 33.859 22.1606C33.3209 22.1606 32.8846 22.8674 32.8846 23.7392C32.8846 24.611 33.3209 25.3178 33.859 25.3178Z"
      fill="#046A37"
    />
    <path
      d="M31.484 41.225C31.484 41.225 33.1282 42.4393 35.7468 42.8035"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.5513 42.8643C45.5513 42.8643 44.0897 43.8964 41.7756 43.8964"
      stroke="#E87524"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.4924 57.9749L49.6405 50.8484L45.5497 46.7699L38.4017 53.8965L42.4924 57.9749Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.0864 53.8971L30.9384 46.7705L26.8476 50.849L33.9957 57.9755L38.0864 53.8971Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.4488 50.6964L45.5513 46.75L38.4263 53.8536C38.3654 53.8536 38.3045 53.8536 38.1827 53.8536C38.1218 53.8536 38.0609 53.8536 37.9392 53.8536L30.9359 46.75L28.4392 49.2393L11.6315 55.4929C6.45518 57.375 3.04492 62.2929 3.04492 67.8179V77.1071H14.859V114.386H57.2436V84.6964V69.8214L71.5545 75.4071L71.7981 74.4357L74.7821 63.6286L75.2693 61.8071L49.4488 50.6964Z"
      stroke="#226937"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
